import { style } from '@do/walrus';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars';

const SuccessBanner = styled.div`
  background: ${vars.green_lightest};
  padding: ${style.vars.whitespace.regular};
  border-radius: ${vars.border_radius_xlarge};
  border: ${style.vars.borderWidth.thin} solid ${vars.green_darkest};
  margin-bottom: ${style.vars.space['4']};
  color: ${vars.dark};

  & img {
    margin-right: ${style.vars.whitespace.small};
    margin-top: -2px;
  }
`;

export default SuccessBanner;
